import enLocale from 'element-ui/lib/locale/lang/en'
import deepmerge from 'deepmerge'
import encode from "./en_code";
let lang = {
  ...encode,
  设备列表: "Device List",
  收款明细: "Payment Details",
  使用明细: "Usage Details",
  智电生态: "APS-CN",
  导出记录: "Export Records",
  APP下载: "APP Download",
  下载手机APP: "Download mobile APP",
  手机管理更方便: "Mobile phone managementis more convenient",
  消息记录: "Message Records",
  价格管理: "Price Management",
  退出登录: "Logout",
  请输入设备名称: "Please enter a device name",
  操作时间: "Operation Time",
  层级名称: "Group Name",
  至: "To",
  导出: "Export",
  查询: "Query",
  序号: "Serial Number",
  用电量kwh: "Electricity Consumption(kW·h)",
  本年收款: "Yearly Income",
  本月收款: "Monthly Income",
  充值金额: "Recharge Amount",
  充值方式: "Recharge Method",
  电量: "Battery Power",
  水量: "Water Volume",
  金额: "Amount",
  交易时间: "Deal Time",
  层级列表: "Group List",
  欢迎登入智电生态: "Welcome to APS-CN",
  您输入的手机号或密码有误请重新输入: "The phone number or password you entered is incorrect. Please re-enter",
  请输入手机号: "Please enter your phone number",
  请输入密码: "Please enter your password",
  记住密码: "Save Password",
  登录: "Log in",
  登录成功: "Logged in successfully",
  长度在6到20个字符: "The length should be between 6 and 20 characters",
  只支持房东登录: "Log in is restricted to landlords only.",
  搜索: "Search",
  中国大陆: "China",
  温馨提示: "Friendly Reminder",
  第一次登录用户为了您的帐户安全请先重置您的登录密码: "If you are logging in for the first time, please change your password to ensure your account security.",
  前往重置: "Set",
  设置新的登录密码: "Set a new login password",
  首次登录用户为了您帐户的安全请先重设您的登录密码: "First time logged in user, for the security of your account,please reset your login password first",
  请输入新密码: "Please enter a new password",
  请再次输入新密码: "Please enter the new password again",
  密码长度必须限制为620个字符并且使用至少1个字母和1个数字: "Password must be between 6 and 20 characters,including at least (1)letter and (1) number",
  密码长度不能小于6位: "Password length must be at least 6 characters",
  密码长度不能大于20位: "Password length must not exceed 20 characters",
  密码至少包含1个字母和1个数字: "Password must contain at least one letter and one digit",
  输入密码不一致: "Passwords do not match",
  导出信息: "Export Information",
  当前无导出数据: "No export data available currently",
  导出记录只保存7天: "Export records are only kept for 7 days",
  导出成功: "Export Successful",
  导出中: "Exporting...",
  总数: "Total",
  刷新: "Refresh",
  文件名称: "File Name",
  创建时间: "Create Time",
  任务状态: "Task Status",
  完成时间: "Completion Time",
  状态信息: "Status Information",
  操作: "Operation",
  下载: "Download",
  删除: "Delete",
  删除成功: "Deleted succeeded",
  您是否确认要删除: "Confirm deleting house group?",
  提示: "Warm Tips",
  确定: "Confirm",
  确认: "Confirm",
  取消: "Cancel",
  个人中心: "Personal Centre",
  电价管理: "Price Management",
  元: "CNY",
  您是否确认要删除该价格: "Are you sure you want to delete this price?",
  删除电价: "Prompt",
  添加电价: "Add Price",
  修改电价: "Change Price",
  电价名称: "Price Name",
  请输入电价名称: "Please enter the price plan name",
  请输入电价金额: "Please enter the unit price",
  单价: "Unit Price",
  请输入单价: "Please enter the current unit price",
  备注: "Remarks",
  请输入备注: "Please enter remarks",
  添加成功: "Add successfully.",
  修改成功: "Modification succeeded.",
  账号信息: "Account Information",
  用户名称: "User Name",
  修改: "Modify",
  修改密码: "Change Password",
  已设置登录密码: "Login password set",
  修改用户名称: "Modify User Name",
  名称: "Name",
  请输入名称: "Please enter a name.",
  旧密码: "Old Password",
  请输入旧密码: "Please enter your old password",
  新密码: "New Password",
  确认密码: "Confirm New Password",
  密码输入不符合规则: "Password input does not conform to the rules.",
  两次密码输入不一致: "The two password entries are inconsistent.",
  添加层级: "Add Group",
  暂无数据: "No Data",
  您是否确认删除该层级: "Confirm deleting house group?",
  修改层级: "Modify Group",
  请输入层级名称: "Please enter group name",
  详细地址: "Detail Address",
  请输入详细地址街道楼牌号等: "city and street",
  请输入: "Please enter",
  设备名称: "Device Name",
  表号: "Serial Number",
  租客姓名: "Tenant Name",
  剩余电量kWh: "Remaining(kW·h)",
  剩余电量2: "Remaining Energy",
  剩余电量3: "Remaining kWh",
  状态: "Status",
  刷新时间: "Refresh Time",
  排序: "Sort",
  全部: "All",
  设备通电: "Connect",
  设备断电: "Disconnect",
  设备离线: "Offline",
  默认排序: "Default sorting",
  由大到小: "Descending Sort",
  由小到大: "Ascending Sort",
  添加设备: "Add Device",
  电价调整: "Price adjust",
  查看详情: "View Details",
  更换租客: "Change Tenant",
  代客充值: "Recharge For Customer",
  资产号: "Serial Number",
  请输入资产号: "Please enter asset number",
  电价方案: "Price",
  请选择电价方案: "Please select",
  安装地址: "Installation Address",
  请输入安装地址: "Please enter installation address",
  请输入租客姓名: "Please enter tenant's name",
  联系电话: "Tenant Phone",
  请输入联系电话: "Please enter tenant phone",
  保存: "Save",
  电价: "Price",
  请选择: "Please select a price",
  元kWh: "CNY/kW·h",
  请选择电价: "Please select the electricity price",
  请选择设备: "Please select a device.",
  所选设备价格与修改价格一致无需修改: "The price of the selected equipment is consistent with the modified price, and no modification is required.",
  美国: "America",
  更换租客成功: "Tenant change succeeded.",
  通电: "Connect",
  断电: "Disconnect",
  离线: "Offline",
  租客名称: "Tenant Name",
  剩余电量: "Remaining",
  剩余水电量: "Water & Power Balance",
  充值电量: "Recharge(Energy)",
  请输入充值电量: "Please enter energy",
  充值金额3: "Money",
  充值电量3: "kWh(kW·h)",
  确认充值: "Confirm Recharge",
  充值成功回执单: "Receipt Of Successful Recharge",
  充值回执单: "Recharge receipt",
  订单编号: "Order Number",
  客户名称: "Customer Name",
  充值Token: "Recharge Token",
  支付时间: "Payment Time",
  我知道了: "OK",
  充值成功: "Recharge succeeded.",
  复制成功: "Copy succeeded.",
  删除设备: "Delete This Device",
  设备信息: "Device Information",
  费用明细: "Transactions",
  操作记录: "Operation Records",
  充值记录: "Recharge Records",
  数据统计仅保留近一年内的记录: "Data statistics only retain records of the past year",
  业主: "Owner",
  操作人: "Operator",
  时间: "Time",
  项目: "Item",
  充值电量kwh: "Recharged Electricity(kW·h)",
  设备类型: "Device Type",
  总用电量: "Total Consumption",
  电流: "Current",
  电压: "Voltage",
  wifi账号: "Wi-Fi Account",
  wifi密码: "Wi-Fi Password",
  设备: "Device",
  成功: "success",
  成功1: "Success",
  清零: "Reset Electricity",
  水表清零: "Reset Water",
  清窃电: "Clear Electricity Theft",
  您是否确认通电: "Are you sure to Connect?",
  您是否确认断电: "Are you sure to Disconnect?",
  您是否要清窃电: "Do you want to Clear electricity theft?",
  您是否要清电量: "Do you want to reset energy?",
  修改价格: "Modify Price",
  您的设备为键盘表需要手动输入Token进行: "Your device is a keypad meter. You need to manually enter the Token to ",
  本次: "The",
  为: "is",
  电表: "Electric Meter",
  水表: "Water Meter",
  修改名称: "Modify Name",
  请选择价格: "Please select a price.",
  电表刷新: "Meter Refresh",
  拉合闸状态: "Relay Status",
  功率因数: "Power factor",
  刷新成功: "Refresh succeeded.",
  当前价格: "Current Price",
  设备消息: "Devices information",
  告警消息: "Alarm Information",
  账号消息: "Account Information",
  公告消息: "Announcement",
  暂无消息: "No news yet.",
  您是否确认删除该设备: "Are you sure to delete this device?",
  请输入最多两位小数的有效数字: "Please enter a valid number with at most two decimal places.",
  加载中: "Loading...",
  刷新失败: "Refresh failed.",
  您还未设置电价: "You have not set the price",
  去设置: "Set",
  您还未创建分组请先添加分组: "You didn't create a group. Please create a group first",
  币种设置: "Currency",
  设置货币: "Currency",
  国家币种: "Country/Currency",
  请输入国家名称或币种名称: "Please enter Country or Currency",
  智电官网: "Website",
  电话: "Phone Number",
  邮箱: "E-mail",
  当前选择已设置: 'The current selection has been set.',
  不能有特殊字符: "Cannot have special characters.",
  阈值设置: "Threshold Setting",
  功率门限阈值: "Power Threshold",
  请输入功率门限阈值: "Please enter the power threshold values",
  读取: "Read",
  设置: "Set Up",
  请输入数字: "Please enter the number",
  历史数据: "History Data",
  日: "Day",
  月: "Month",
  年: "Year",
  序号2: "No.",
  分组名称: "Group Name",
  总电量: "Total Consumption",
  总水量: "Total Water Consumption",
  A相电压: "Phase A voltage",
  B相电压: "Phase B voltage",
  C相电压: "Phase C voltage",
  A相电流: "Phase A Current",
  B相电流: "Phase B Current",
  C相电流: "Phase C Current",
  功率因素: "Power Factor",
  选择日期: "Select date",
  阈值范围: "The threshold range is 10-1000000w W.",
  读取成功: "Reading succeeded.",
  设置成功: "Set successfully.",
  水价方案: "Price",
  请选择水价方案: "Please select",
  添加水价方案: "+Add The Water Price Plan",
  价格调整: "Price Adjust",
  水价: "Water Price",
  热水价: "Hot Water Price",
  批量修改电价: "Batch Modify Electricity Prices ",
  批量修改水价: "Batch Modify Water Prices ",
  水价管理: "Water Price Management",
  添加水价: "Add Water Price ",
  修改水价: "Change Water Price ",
  水价名称: "Water Price Name",
  请输入水价名称: "Please Enter The Name Of The Water Price ",
  请输入水价金额: "Please Enter The Amount Of Water Price ",
  水价类型: "Water Price Type ",
  删除水价: "Delete The Water Price ",
  剩余水量: "Surplus Water",
  剩余水量2: "Remaining Water",
  剩余额度: "Remaining Quota",
  充值水量: "Recharge Water Volume",
  请输入充值水量: "Please enter water volume",
  开阀: "Valve Open",
  关阀: "Valve Close",
  总用水量: "Total Consumption",
  当月用水量: "Monthly Consumption",
  水表操作提醒: "There Are No Operation Commands At Present ",
  您是否要清水量: "Would You Like Some Clear Water ",
  您是否确认开阀: "Have You Confirmed To Open The Valve",
  您是否确认关阀: "Have You Confirmed To Close The Valve",
  昨日用水量: "Yesterday's water consumption ",
  用水量m: "Water Consumption(m³)",
  充值水量1: "Recharge Water Volume(m³)",
  设备通电开阀: "Connect/Valve Open",
  设备断电关阀: "Disconnect/Valve Close",
  阀控故障: "Valve Fault",
  继电器故障: "Relay Fault",
  支付方式: "Payment Method",
  支付宝: "Alipay",
  银行卡: "Bank Card",
  微信: "Wechat Pay",
  支付宝小程序: "Alipay Mini Program",
  微信小程序: "Wechat Mini Program",
  Paystack: "Paystack",
  线下支付: "Offline Payment",
  操作成功: "Operation Succeeded",
  二级密码: "Secondary Password",
  验证二级密码: "Verify Secondary Password",
  请输入二级密码: "Please enter your secondary password",
  请再次输入二级密码: "Please re-enter your secondary password",
  已设置二级密码: "Secondary Password Already Set",
  删除密码: "Delete Password",
  您正在操作删除二级密码请完成校验: "You are currently deleting your secondary password. Please complete the verification.",
  未设置: "Not Set",
  付费模式: "Payment Mode",
  预付费: "Prepaid",
  后付费: "Postpaid",
  远程抄表: "Remote Meter Reading",
  账单列表: "Bill List",
  账单年月: "Billing Year And Month",
  账单状态: "Bill Status",
  批量收款: "Batch Receiving Payment",
  总用金额: "Total Amount Used",
  收款日期: "Receiving Payment Date",
  确认收款: "Confirm Payment",
  收款时间: "Received Payment time",
  未收款: "Unpaid Payment",
  已收款: "Received Payment",
  逾期: "Overdue Payment",
  异常: "Exception",
  未知: "Unknown",
  前往: "Go to handle",
  原模式: "Original Mode",
  待执行: "To be set",
  目标模式: "Target Mode",
  失败原因: "Reason for failure",
  失败重试: "Retry",
  总用水电量: "Total Water And Electricity Consumption",
  请勾选要批量收款的账单: "Please select the bill for batch Payment",
  请输入账号: "Please enter your account",
  您输入的账号或密码有误请重新输入: "The account or password you entered is incorrect. Please re-enter.",
  失败: "Failed",
  付费模式设置: "Payment mode settings",
  预付费模式: "Prepaid Mode",
  先充值再用电欠费自动断电: "Recharge first, then use electricity. If you owe, the power will automatically be cut off.",
  当前模式: "Current mode",
  切换至此: "Switch mode here",
  后付费模式: "Post Payment Mode",
  先用电后付费账单月结逾期自动断电: "Use electricity first, pay later, pay monthly bills, and automatically cut off power if overdue.",
  远程抄表模式: "Remote Meter Reading Mode",
  远程自动采集记录用户用电等数据无计费功能: "Remote automatic collection and recording of user electricity consumption data, without billing function.",
  切换设备列表: "Switch Device List",
  切换状态: "Switch State",
  没有可重试的设备: "There are no devices to retry",
  您确定要对切换失败的设备进行重试吗: "Are you sure you want to retry the device that failed to switch?",
  正在重试: "Retrying",
  缴费截止日期: "Payment Deadline",
  请填写缴费截止日期: "Please fill in the Payment deadline",
  时: "Hour",
  逾期断电: "Overdue power outage",
  开启: "Enabled",
  关闭: "Disabled",
  您即将切换付费模式此操作会导致剩余电量清零: "You are about to switch to Payment mode, which will cause the remaining battery to be reset to zero.",
  您即将切换付费模式切换后系统将实时扣费请确保账户余额充足: "You are about to switch the Payment mode, and the system will deduct fees in real-time. Please ensure that your account balance is sufficient.",
  您确定要将付费模式切换为: "Are you sure you want to switch the Payment mode to ",
  日期输入范围为: "The date input range is",
  小时输入范围为: "The input range for hours is",
  您有设备未完成付费模式切换请及时处理: "You have a device that has not completed the Payment mode switch. Please handle it promptly.",
  开始时间: "Start Time",
  结束时间: "End Time",
  开始示数: "Start Counting",
  结束示数: "End Counting",
  安卓版下载: "Android Version Download",
  扫描下载安卓版: "Scan and download Android version",
  iOS版下载: "IOS Version Download",
  扫描下载iOS版: "Scan and download IOS version",
  联系方式: "Contact Us",
  智慧用电: "Smart Energy Cloud",
  更新公告: "Notice on the Upgrade of the Recharge System Interface",
  更新内容信息1: "Dear Users, Greetings!",
  更新内容信息:
    "To optimize service experience and improve system operation efficiency, our <br/>" +
    "company will officially launch the brand-new interface of the recharge system on <br/>" +
    "January 19, 2026 . After the completion of this upgrade, all data from the original <br/>" +
    "system will be fully migrated to the new system to ensure data integrity and <br/>" +
    "accuracy.This upgrade will not affect the usage logic of the original functions, <br/>" +
    "and your account information remains unchanged. When logging into the new <br/>" +
    "system, there is no need to manually select the area code. You can directly enter <br/>" +
    "the original account format (hk +xxxxxx) and the original password to log in and <br/>" +
    "use the system normally.If you encounter any problems during login or usage, <br/>" +
    "please feel free to contact us via the contact information in the Contact us.We will <br/>" +
    "wholeheartedly provide you with technical support and solutions.",
  更新内容信息2: "Thank you for your understanding and support!",
  不再提醒: "No more reminders",
  打印: "Print",
  查看回执单: "Check The Receipt",
}

let en = deepmerge({ lang }, enLocale, { clone: true })
export default en
